/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Lifecycle state.
 */
export const InternalSessionIssuerKeyState = {
  Pending: "pending",
  Active: "active",
  Retired: "retired",
} as const;
/**
 * Lifecycle state.
 */
export type InternalSessionIssuerKeyState = OpenEnum<
  typeof InternalSessionIssuerKeyState
>;

export type InternalSessionIssuerKey = {
  /**
   * Key ID.
   */
  kid: string;
  /**
   * Lifecycle state.
   */
  state: InternalSessionIssuerKeyState;
};

/** @internal */
export const InternalSessionIssuerKeyState$inboundSchema: z.ZodMiniType<
  InternalSessionIssuerKeyState,
  unknown
> = openEnums.inboundSchema(InternalSessionIssuerKeyState);

/** @internal */
export const InternalSessionIssuerKey$inboundSchema: z.ZodMiniType<
  InternalSessionIssuerKey,
  unknown
> = z.object({
  kid: z.string(),
  state: InternalSessionIssuerKeyState$inboundSchema,
});

export function internalSessionIssuerKeyFromJSON(
  jsonString: string,
): SafeParseResult<InternalSessionIssuerKey, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => InternalSessionIssuerKey$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'InternalSessionIssuerKey' from JSON`,
  );
}
